// @flow

import React, { Component } from 'react'
import { AnimatedSwitch } from 'react-router-transition'
import { withRouter } from 'react-router-dom'
import type { RouterHistory } from 'react-router'
import './index.css'

type Props = {
  children: React$Element,
  history: RouterHistory,
}

type State = {
  invert: boolean,
  currentPage: ?string,
  previousPage: ?string,
  stack: Array<string>,
}

function pageTransitions(action) {
  return {
    atEnter: {
      offset: action === 'PUSH' ? 600 : -600,
      opacity: 1,
    },
    atLeave: {
      offset: action === 'PUSH' ? -600 : 600,
      opacity: 0,
    },
    atActive: {
      offset: 0,
      opacity: 1,
    },
  }
}

class AnimatedSwitchPagination extends Component<Props, State> {
  state = {
    previousPage: undefined,
    currentPage: undefined,
    stack: [],
  }

  mapStyles = styles => {
    let offset = styles.offset
    offset = `${offset}px`

    return {
      opacity: styles.opacity,
      transform: `translateX(${offset})`,
    }
  }

  componentWillReceiveProps() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <AnimatedSwitch
        className="switch-wrapper"
        runOnMount={location.pathname === '/'}
        {...pageTransitions(this.props.history.action)}
        mapStyles={this.mapStyles}
      >
        {this.props.children}
      </AnimatedSwitch>
    )
  }
}

export default withRouter(AnimatedSwitchPagination)
